// UCC tab Baselayer integration — standalone transport for the loan
// debtor-prefill endpoint plus the manual servicing UCC-1 record call
// (POST /portfolio-admin/ucc/file-initial). Kept out of client.ts so the
// UCC-tab rebuild owns its own api surface.

import { api } from "../client";
import type { FileUcc1Request, UccFilingDto } from "./types";

/** Server-assembled UCC-1 prefill for a loan: debtor block from the loan's
 *  counterparties, secured party = Phoenix. Tax identifiers (EIN/SSN/TIN)
 *  are deliberately never included. */
export interface UccDebtorPrefillDto {
  dealId: string | null;
  debtorLegalName: string;
  debtorType: string | null;
  debtorMailingLine1: string | null;
  debtorCity: string | null;
  debtorState: string | null;
  debtorZip: string | null;
  debtorJurisdictionOfOrg: string | null;
  securedPartyLegalName: string;
  filingState: string | null;
}

export const uccPrefillApi = {
  getDebtorPrefill: (loanId: string) =>
    api.get<UccDebtorPrefillDto>(
      `/portfolio-admin/loans/${loanId}/ucc-debtor-prefill`,
    ),
  /** Manual servicing path: record a UCC-1 already filed with the filing
   *  office (standard procedure when the Baselayer workspace isn't used). */
  fileInitial: (body: FileUcc1Request) =>
    api.post<UccFilingDto>(`/portfolio-admin/ucc/file-initial`, body),
};
